/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientVolunteerAssignmentResponse
 */
export interface ClientVolunteerAssignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientVolunteerAssignmentResponse
     */
    volunteerId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientVolunteerAssignmentResponse
     */
    username: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientVolunteerAssignmentResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientVolunteerAssignmentResponse
     */
    lastName: string | null;
}

/**
 * Check if a given object implements the ClientVolunteerAssignmentResponse interface.
 */
export function instanceOfClientVolunteerAssignmentResponse(value: object): value is ClientVolunteerAssignmentResponse {
    if (!('volunteerId' in value) || value['volunteerId'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ClientVolunteerAssignmentResponseFromJSON(json: any): ClientVolunteerAssignmentResponse {
    return ClientVolunteerAssignmentResponseFromJSONTyped(json, false);
}

export function ClientVolunteerAssignmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientVolunteerAssignmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'volunteerId': json['volunteerId'],
        'username': json['username'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function ClientVolunteerAssignmentResponseToJSON(json: any): ClientVolunteerAssignmentResponse {
    return ClientVolunteerAssignmentResponseToJSONTyped(json, false);
}

export function ClientVolunteerAssignmentResponseToJSONTyped(value?: ClientVolunteerAssignmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'volunteerId': value['volunteerId'],
        'username': value['username'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

